<template>
<div>.. loading ..</div>
</template>



<script>

export default {
    name: "message",
    data() {
        return {}
    },
    methods: {
  },
  mounted() {
  }
};
</script>